module.exports = __webpack_public_path__ + "static/media/1.c1bf92e3.png";